import { useContext } from 'react';

import { RegisterContext } from '.';

export const useRegisterStore = () => {
  return useContext(RegisterContext);
};
